export default __webpack_public_path__ + "static/media/googleLogin.286f4622.svg";